import React, { useRef } from 'react';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import Message from '@app/component/message/Message';
import MetaradarDailyReportFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__metaradar/fragment/MetaradarDailyReportFragment';
import MetaradarSettingsFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__metaradar/fragment/MetaradarSettingsFragment';
import DrawerHandler from '@app/component/overlays/drawer/DrawerHandler';

const MetaradarPage = React.memo(() => {

	const { companyHotel } = useSelectedCompanyHotel();
	const metaradarSettingsRef = useRef<DrawerHandler>(null);

	if (!companyHotel.metaradarSettings)
		return <main>
			<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8 items-center">
				<div className="lg:flex lg:h-full lg:flex-col">
					<Message state="info">
						Please configure your metaradar settings to view results! <a className="underline cursor-pointer"
																																				 onClick={() => metaradarSettingsRef.current?.open()}>
						Click here
					</a>
					</Message>
					<MetaradarSettingsFragment ref={metaradarSettingsRef} />
				</div>
			</div>
		</main>;

	return <main>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8 items-center">
			<div className="lg:flex lg:h-full lg:flex-col">
				<MetaradarDailyReportFragment onOpenSettings={() => metaradarSettingsRef.current?.open()} />
			</div>
		</div>
		<MetaradarSettingsFragment ref={metaradarSettingsRef} />
	</main>;
});

export default MetaradarPage;